<template>
  <div>
    <b-modal
      v-model="modalShown"
      @shown="focusMyElement"
      @ok="submit"
      size="sm"
      title="Imprimir etiquetas"
    >
      <b-form @submit.prevent="submit">
        <b-form-group>
          <b-form-input
            type="text"
            id="label_quantity"
            ref="focusThis"
            autocomplete="off"
            :state="$v.label_quantity.$dirty ? !$v.label_quantity.$error : null"
            v-model="$v.label_quantity.$model"
            placeholder="Ingrese cantidad de etiquetas"
            v-on:keyup="inputSoloNumero"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import {
  integer,
  required,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

import { setup, Printer } from "../assets/js/printFunctionsBagnos.js";

export default {
  name: "printModal",
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      label_quantity: null,
      modalShown: false,
      contentPrint: "",
      typeLabel: 1
    };
  },
  methods: {
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    submit() {
      Object.assign(this.contentPrint, {
        document_number: this.form.document_number
      });
      this.$bvModal.hide("print-modal");
      Printer(this.contentPrint, this.typeLabel, this.label_quantity);
      this.label_quantity = null;
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  },
  validations: {
    label_quantity: {
      minValue: minValue(0),
      maxValue: maxValue(4),
      required,
      integer
    }
  }
};
</script>

<style scoped></style>
